import { ReportingPeriods } from './reporting-periods';
import { ArtifactTypes } from "./artifact-types";
import { ArtifactFileFormats } from "./artifact-file-formats";
import { IGridRow } from "./grid.model";
import { SubmissionArtifact } from "./submission-artifact.model";
import { ViewRollupArtifactResponse } from "./rollup-artifact.model";
import { EntityTypes } from "./entity-types";

export abstract class BaseArtifact implements IGridRow{
  rowId: string;
  id: string;
  cdsCode: string;
  fullFiscalYear: string;
  reportingPeriod: ReportingPeriods;
  name: string;
  date: string;
  type: ArtifactTypes;
  fileName: string;
  fileFormat: ArtifactFileFormats;
  published: boolean;
  icon: string;
  label: string;
  ariaLabel: string;
  loading: boolean;
}

export class Request {
  fullFiscalYear: string;
  reportingPeriod: ReportingPeriods;
  cdsCode: string;
  submissionNumber: string;
  includeArtifactTypes: Array<ArtifactTypes>;
  excludeArtifactTypes: Array<ArtifactTypes>;

  constructor(init?: Partial<Request>) {
    Object.assign(this, init);
  }
}

export class DownloadArtifact {
  artifact: SubmissionArtifact | ViewRollupArtifactResponse
  isRollup: boolean

  constructor(init?: Partial<DownloadArtifact>) {
    Object.assign(this, init);
  }
}

export class FilterArtifacts {
  fullFiscalYear: string;
  reportingPeriod: ReportingPeriods;
  cdsCode: string;
  entityType: EntityTypes

  constructor(init?: Partial<FilterArtifacts>) {
    Object.assign(this, init);
  }
}